import * as z from "zod";

export const LiveEsportMatchSchema = z.object({
  livestreamStartTime: z.string().nullable(),
  livestreamEndTime: z.string().nullable(),
});

export const LiveEsportMatch = LiveEsportMatchSchema;
export type LiveEsportMatch = z.infer<typeof LiveEsportMatchSchema>;
